import { all, call, put, takeLatest } from "redux-saga/effects";

import { getErrorMessage } from "../../../../utils/sagasErrorHandler";
import { sharedHistory } from "../../../../routes/sharedHistory";
import { ROUTES_MAP } from "../../../../routes/constants";
import {ITEMS_PER_PAGE} from "../../../../constants/general";
import queryString from "query-string";

import {
    createUser,
    createUserError,
    createUserSuccess,
    deleteUser,
    deleteUserError,
    deleteUserSuccess,
    getUserByID,
    getUsers,
    getUsersByIDError,
    getUsersByIDSuccess,
    getUsersError,
    getUsersSuccess,
    updateUser,
    updateUserError,
    updateUserSuccess
} from "./actions";
import { getUsersRequest, createUserRequest, updateUserRequest, deleteUserRequest, getUserRequest } from "./api";

//Workers
function* handleRefreshUsers() {
    const { search } = window.location;
    yield put(getUsers({ limit: ITEMS_PER_PAGE, ...queryString.parse(search) }));
}

function* handleGetUsers ({ payload }) {
    try {
        const usersData = yield call(getUsersRequest, payload);

        yield put(getUsersSuccess(usersData));
    } catch (error) {
        yield put(getUsersError());
        getErrorMessage(error);
    }
}

function* handleGetUserByID ({ payload }) {
    try {
        const usersData = yield call(getUserRequest, payload);

        yield put(getUsersByIDSuccess(usersData));
    } catch (error) {
        yield put(getUsersByIDError());
        getErrorMessage(error);
    }
}

function* handleCreateUser ({ payload }) {
    try {
        yield call(createUserRequest, payload);
        yield put(createUserSuccess());
        sharedHistory.push(ROUTES_MAP.users.path);
    } catch (error) {
        yield put(createUserError());
        getErrorMessage(error);
    }
}

function* handleUpdateUser ({ payload }) {
    try {
        yield call(updateUserRequest, payload);
        yield put(updateUserSuccess());

        sharedHistory.push(ROUTES_MAP.users.path);
    } catch (error) {
        yield put(updateUserError());
        getErrorMessage(error);
    }
}

function* handleDeleteUser ({ payload }) {
    try {
        yield call(deleteUserRequest, payload);
        yield put(deleteUserSuccess());
        yield handleRefreshUsers();
    } catch (error) {
        yield put(deleteUserError());
        getErrorMessage({}, "Oops! Something went wrong, we can not delete the user!");
    }
}

// Watchers
export function* usersEntriesSagas() {
    yield all([
        yield takeLatest(getUsers, handleGetUsers),
        yield takeLatest(getUserByID, handleGetUserByID),
        yield takeLatest(createUser, handleCreateUser),
        yield takeLatest(updateUser, handleUpdateUser),
        yield takeLatest(deleteUser, handleDeleteUser)
    ]);
}
